export const DEFAULT_REFRESH_RATE = 10000;
//# sourceMappingURL=fallbacks.js.map